import { render, staticRenderFns } from "./SearchDetail.vue?vue&type=template&id=706334ac&scoped=true"
import script from "./SearchDetail.vue?vue&type=script&lang=js"
export * from "./SearchDetail.vue?vue&type=script&lang=js"
import style0 from "./SearchDetail.vue?vue&type=style&index=0&id=706334ac&prod&lang=scss&scoped=true"
import style1 from "./SearchDetail.vue?vue&type=style&index=1&id=706334ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706334ac",
  null
  
)

export default component.exports